import classNames from 'classnames'
import { PhoneMockupProps } from './types'

export const PhoneMockup = ({
  className,
  src,
  alt,
  ...props
}: PhoneMockupProps) => {
  return (
    <div className={classNames('relative', className)} {...props}>
      <img
        src={src}
        className="absolute inset-0 w-full h-full object-cover rounded-[10%] px-[4%] py-[4%]"
        alt={alt}
      />
      <img
        src="https://cdn.shopify.com/s/files/1/0929/1494/files/phone-mockup.webp?v=1701944075"
        className="relative object-contain max-h-[100%]"
        role="presentation"
      />
    </div>
  )
}
